module.exports = require('lib/storage-factory')(window.sessionStorage)



// WEBPACK FOOTER //
// ./app/scripts/lib/session-storage.coffee